import { render, staticRenderFns } from "./LegalDatabases.vue?vue&type=template&id=7fcca84c"
import script from "./LegalDatabases.vue?vue&type=script&lang=js"
export * from "./LegalDatabases.vue?vue&type=script&lang=js"
import style0 from "./LegalDatabases.vue?vue&type=style&index=0&id=7fcca84c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports